import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import Search from '../../searches/Search';
import SearchResults from '../../searches/Search/SearchResults';
import PropertyCardBase from '@molecules/PropertyCard';
import PropertyListItemBase from '@molecules/PropertyListItem';
import LoadingArea from '@molecules/LoadingArea';
import { BodyLarge, ButtonLink, DivWithShadowAlternate, H4 } from '@styled';

import usePropertyMatchFilters from '../../../hooks/algoliaFilters/usePropertyMatchFilters';
import useSavedSearches from '../../../hooks/useSavedSearches';
import { SearchModeContext } from '../../../../../algolia-search/js/context/searchContext'; // TODO: Cross module - consider making this shared
import { mapSearchPropertyToProps } from '@general/transforms/property.transform';
import { SAVED_PROPERTIES_QUERY } from '@general/graphql/properties.graph';

const PropertyCard = props => <PropertyCardBase openInNewTab {...props} />;
const PropertyListItem = props => <PropertyListItemBase openInNewTab {...props} />;

const RecentPropertiesInMyArea = () => {
    const history = useHistory();
    const [savedSearchesForSpace, setSavedSearchesForSpace] = useState();

    useSavedSearches({
        onCompleted: ({ savedSearches }) => {
            setSavedSearchesForSpace(savedSearches.filter(savedSearch => savedSearch.primaryInterest === 'SPACE'));
        },
    });

    const { filters } = usePropertyMatchFilters({ savedSearches: savedSearchesForSpace });

    if (!savedSearchesForSpace) {
        return <LoadingArea />;
    }

    return (
        <div>
            <H4 className="font-weight-bold">Recent Properties in My Area of Business</H4>

            <DivWithShadowAlternate className="mt-3 p-3">
                {savedSearchesForSpace.length === 0 && (
                    <div className="p-1rem">
                        <BodyLarge className="mb-1rem">
                            Create a match criteria to see properties around your area of business.
                        </BodyLarge>

                        <ButtonLink
                            href="/my-icsc/connections/matches/new"
                            onClick={e => {
                                e.preventDefault();
                                history.push('/my-icsc/connections/matches/new');
                            }}
                        >
                            Create Match Criteria
                        </ButtonLink>
                    </div>
                )}

                {savedSearchesForSpace.length > 0 && (
                    <SearchModeContext.Provider value={{ showFilters: false }}>
                        <Search
                            displaySearchBox={false}
                            displaySearchOptions={false}
                            filters={filters}
                            hitsPerPage={6}
                            index="properties_activated_at_desc_virtual"
                        >
                            <SearchResults
                                cardComponent={PropertyCard}
                                index="properties_activated_at_desc_virtual"
                                listItemComponent={PropertyListItem}
                                parentView="Properties"
                                parentSubview="Find Properties"
                                query={SAVED_PROPERTIES_QUERY}
                                transformFunc={mapSearchPropertyToProps}
                                typePlural="savedProperties"
                                resultsPerRow={3}
                                NoResultsText={() => 'No Recent Properties in Your Area of Business.'}
                            />
                        </Search>
                    </SearchModeContext.Provider>
                )}
            </DivWithShadowAlternate>
        </div>
    );
};

RecentPropertiesInMyArea.propTypes = {
    //
};

export default RecentPropertiesInMyArea;
